global.$ = global.jQuery = require("jquery");
import tippy from 'tippy.js';
import tether from 'tether';
import iziToast from "izitoast";
global.iziToast = iziToast;

require("./functions.js");
require("./jquery.plugins.js");
require("./scripts-eshop.js");
require("./bootstrap.min.js?v1");
require("./jquery.bxslider.min.js");
require("jcarousellite/jcarousellite.js");
require("slick-carousel");
require('waypoints/lib/jquery.waypoints.js');
require('./waypoints');
require('./modernizr-blend');
require('magnific-popup');
require('./menu');
require('./forms');
require('./carousel');
require('./video');
require('./popup_news');

import datepickerFactory from 'jquery-datepicker';
import datepickerCSFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-cs';

datepickerFactory($);
datepickerCSFactory($);

// window.addEventListener("load", function () {
// 	window.cookieconsent.initialise({
// 		"palette": {
// 			"popup": {
// 				"background": "#FFFFFF"
// 			},
// 			"button": {
// 				"background": "#ff6600"
// 			}
// 		},
// 		"theme": "classic",
// 		"position": "bottom",
// 		"content": {
// 			"message": "Tento web používá k poskytování služeb, personalizaci reklam a analýze návštěvnosti soubory cookie. Používáním webu s tímto souhlasíte.",
// 			"dismiss": "Rozumím",
// 			"link": "Další informace",
// 			"href": "https://policies.google.com/technologies/cookies?hl=cs"
// 		}
// 	});
// });

function textAreaAdjust(o) {
	o.style.height = "1px";
	o.style.height = (10 + o.scrollHeight) + "px";
}

var leasingModelOpen = false;

$(document).ready(function () {

	$(".filters__switch__button").on('click', function() {
		$("#catalog__filters").toggleClass('active');
	});

	$(".image--link").magnificPopup({
		type:'image',
		closeOnContentClick: true,
		closeOnBgClick: true,

	});

	$(".gallery-image").magnificPopup({
		type:'image',
		closeOnContentClick: true,
		closeOnBgClick: true,
		markup: '<div class="mfp-close"></div>' +
			'<div class="mfp-figure">'+
			'<div class="mfp-img"></div>'+
			'</div>'+
			'</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
		gallery: {
			enabled: true, // set to true to enable gallery
			preload: [0,2], // read about this option in next Lazy-loading section
			navigateByImgClick: true,
			arrowMarkup: '<button title="%title%" type="button" class="gallery-arrow-%dir%"></button>', // markup of an arrow button

			tPrev: 'Předchozí', // title for left button
			tNext: 'Další', // title for right button
			tCounter: '' // markup of counter
		}
	});

	$(".gallery-image-replace").click(function(event){
		event.preventDefault();
		event.stopPropagation();
		$(this).parents('.product-images').find('.product-main-img').attr('src', $(this).attr('href'));
		$(this).parents('.product-images').find('.gobig .detail-gallery-image').attr('href', $(this).attr('href'));
		var image = $(".product-images .gobig")[0];
		if(!isInViewport(image))
		{
			image.scrollIntoView();
		}
	});

	$(".gobig .detail-gallery-image").on('click', function(event) {
		event.preventDefault();

		var galleryImages = [];

		galleryImages.push($(this).attr('href'));

		$(".detail-gallery-image").each(function() {
			galleryImages.push($(this).attr('href'));
		});

		var galleryImages = galleryImages.filter(function(item, pos, self) {
			return self.indexOf(item) == pos;
		})

		for(var i in galleryImages) {
			galleryImages[i] = { src: galleryImages[i], type: 'image'}
		}

		$.magnificPopup.open({
			items: galleryImages,
			type:'image',
			closeOnContentClick: true,
			closeOnBgClick: true,
			markup: '<div class="mfp-close"></div>' +
				'<div class="mfp-figure">'+
				'<div class="mfp-img"></div>'+
				'</div>'+
				'</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
			gallery: {
				enabled: true, // set to true to enable gallery
				preload: [0,2], // read about this option in next Lazy-loading section
				navigateByImgClick: true,
				arrowMarkup: '<button title="%title%" type="button" class="gallery-arrow-%dir%"></button>', // markup of an arrow button

				tPrev: 'Předchozí', // title for left button
				tNext: 'Další', // title for right button
				tCounter: '' // markup of counter
			}
		}, 0);
	});

	$(".leasing_popup_open").on("click", function (event) {
		event.preventDefault();
		var changeMenuSnap = $("body").hasClass("product-menu--snap");
		if(!leasingModelOpen) {
			$.nmManual("#leasing__popup", {
				closeButton: '<a href="#" class="nyroModalClose nyroModalCloseButton leasingModal--close" title="close"></a>',
				callbacks: {
					beforeShowBg: function() {
						$("body").addClass("leasing__popup--opened");
						waypoints.onScrollDown();
						if(!changeMenuSnap) {
							$("body").addClass("product-menu--snap");
						}
					},
					afterHideBg: function () {
						$("body").removeClass("leasing__popup--opened");
						if(!changeMenuSnap) {
							$("body").removeClass("product-menu--snap");
						}
					},
					close: function () {
						leasingModelOpen = false;
						console.log("modal closed");
					}
				}
			});
			leasingModelOpen = true;

			$(".nyroModalCont").addClass("leasingModal");
		}
	})


	tippy('.tippy', {
		interactive: true,
		theme: 'ktmchladek',
		allowHTML: true,
		placement: 'top-start'
	});

	tippy('.tippy-white', {
		interactive: true,
		theme: 'ktmchladek_white',
		allowHTML: true
	});

	$(".nav-tabs a").click(function () {
		var target = $(this).attr("aria-controls");
		var caller = $(this);
		$(this).parents(".wrap").find(".tab-target.active").fadeOut("fast", function () {
			$(this).removeClass("active");
			caller.parents(".wrap").find(".tab-target[target='" + target + "']").addClass("active").fadeIn("fast");
		})
	});

	$(".ico-play").click(function () {
		// console.log("sdf");
		var theModal = $(this).data("target");
		var videoSRC = $(this).attr("data-theVideo");
		$(theModal + ' iframe').attr('src', videoSRC);
		$(theModal + ' button, .video-modal').click(function () {
			$(theModal + ' iframe').attr('src', "");
		});
	});

	/*$("textarea").each(function(){
		$(this).css("overflow", "hidden");
		textAreaAdjust(this);
		$(this).on("keyup", function(){
			textAreaAdjust(this);
		});
	});*/

	$(".customform .close-link").click(function (event) {
		event.preventDefault();
		$.nmTop().close();
	});
	// #form pro testovaci jizdu

	$(".pagination .page").hide();

	// ESHOP //
	$("#useShippingAddress").on("change", function () {
		$("#shippingAddress").toggleClass('active');
	});

	if ($("#useShippingAddress").attr("checked") == "checked") {
		$("#shippingAddress").toggleClass('active');
	}

	$("#shipping_payment_form input").change(function () {
		checkRadioButtons();
	});

	function checkRadioButtons() {
		var person = $('#shippingMethod-person').is(':checked');
		var noship = $('#shippingMethod-noshipping').is(':checked');

		$("#paymentMethod-cash").attr('disabled', !person && !noship);

		$("#paymentMethod-cod").attr('disabled', person || noship);
		$("#paymentMethod-invoice").attr('disabled', person);

		if (person || noship) {
			if ($('#paymentMethod-cod').is(':checked')) {
				$("#paymentMethod-delivery").prop('checked', false);
				$("#paymentMethod-cash").prop('checked', true);
			}
		} else {
			if ($('#paymentMethod-cash').is(':checked')) {
				$("#paymentMethod-cash").prop('checked', false);
				$("#paymentMethod-cod").prop('checked', true);
			}
		}
	}

	checkRadioButtons();

	$("#sortby").on('change', function () {
		url = $(this).attr('url');
		val = $(this).find("option:checked").val();
		if (url.indexOf('orderby') != -1) {
			url = url.replace(/orderby=\w+/, 'orderby=' + val);
		} else if (url.indexOf('?') != -1) {
			url = url + '&orderby=' + val;
		} else {
			url = url + '?orderby=' + val;
		}

		window.location.href = url;
	});

	$("#showcount").on('change', function () {
		url = $(this).attr('url');
		val = $(this).find("option:selected").val();
		if (url.indexOf('perpage') != -1) {
			url = url.replace(/perpage=[^&]+/, 'perpage=' + val);
		} else if (url.indexOf('?') != -1) {
			url = url + '&perpage=' + val;
		} else {
			url = url + '?perpage=' + val;
		}

		window.location.href = url;
	});

	$(".whishlistAdd").click(function () {
		productId = $(this).attr("productId");
		data = {
			"page": "eshopCustomer",
			"subpage": "whishlist",
			"action": "add",
			"productId": productId,
			"ajax": 1
		}
		$.post(ROOT, data, function (data) {
			location.reload()
		}, "json");
		return false;
	});

	$(".whishlistRemove").click(function () {
		productId = $(this).attr("productId");
		data = {
			"page": "eshopCustomer",
			"subpage": "whishlist",
			"action": "remove",
			"productId": productId,
			"ajax": 1
		}
		$.post(ROOT, data, function (data) {
			location.reload()
		}, "json");
		return false;
	});

	function switchWhishlistButton(button) {
		if (button.hasClass("whishlistAdd")) {
			button.removeClass("whishlistAdd").addClass("whishlistRemove").text("odebrat produkt");
		} else {
			button.removeClass("whishlistRemove").addClass("whishlistAdd").text("přidat produkt");
		}
	}

	$("#order_submit").submit(function (event) {
		$("#order_submit .order-continue").attr("disabled", "disabled");
	});

	$(".orderSubmitError .close-link").click(function (event) {
		event.preventDefault();
		$.nmTop().close();
		$('html, body').animate({
			scrollTop: $("#confirm_order").offset().top - 100
		}, 2000);
	});
	// eshop varianty

	$("#color-select, #size-select").change(function () {
		var color = $("#color-select").val();
		var size = $("#size-select").val();
		if (typeof color == "undefined") {
			color = "";
		}
		if (typeof size == "undefined") {
			size = "";
		}
		var combination = color + "-" + size;

		if (typeof combinations[combination] != "undefined") {
			window.location.replace(combinations[combination]);
		}

	});

	// // eshop varianty

	$(".tooltip").cluetip({
		splitTitle: '|', // use the invoking element's title attribute to populate the clueTip...
		// ...and split the contents into separate divs where there is a "|"
		showTitle: false, // hide the clueTip's heading
		tracking: true,
		topOffset: 40,       // Number of px to offset clueTip from top of invoking element. more info below [3]
		leftOffset: 15,       // Number of px to offset clueTip from left of invoking element. more info below [4]
	});

	//po odscrolovani se prida classa boxu menu

/*	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		if (jQuery(window).width() >= 800) {
			$(".navigations").removeClass("offscreen");
			$('.nav').removeClass("active");
			$('.nav').removeClass("fixit");
			$('#hamburger').removeClass("active");
			$('.nav-category-doplnky').removeClass("fixit");
			$('.nav-category-doplnky').removeClass("active");
			$('.navigation-doplnky-box').removeClass("offscreen");
			$('.fixedhead').removeClass("fixit");
			$('#catalog_compare').removeClass("offscreen");
			//>=, not <=
			if (scroll >= 90) {
				$('.nav').addClass("fixit");
				$(".navigations").addClass("offscreen");
				$('.short .nav-category-doplnky').addClass("fixit");
				$('.navigation-doplnky-box.short').addClass("offscreen");
			}
			if (scroll >= 105) {
				$('.short .nav-category-doplnky').addClass("fixit");
				$('.navigation-doplnky-box.short').addClass("offscreen");
			}
			if (scroll >= 633) {
				$('.nav-category-doplnky').addClass("fixit");
				$('.navigation-doplnky-box').addClass("offscreen");
			}
			if (scroll >= 455) {
				$('.fixedhead').addClass("fixit");
				$('#catalog_compare').addClass("offscreen");
			}
		}
	}); //missing );*/

	// po kliknuti se prida classa hamburgerovi atd.
	$("#hamburger").click(function () {
		$('.nav').toggleClass("active");
		$('.nav-category-doplnky').toggleClass("active");
		$(this).toggleClass("active");
	});

	// po kliknuti se prida classa hamburgerovi pro mobily atd.
	$("#hamburger2").click(function () {
		$('.header').toggleClass("mobile-active");
		$(this).toggleClass("active");
	});

	// po kliknuti se prida classa hamburgerovi pro mobily atd.
	$("#hamburger--doplnky").click(function () {
		$('.container.nav-category-doplnky').toggleClass("tablet--hidden");
		$(this).toggleClass("active");
	});

	// po kliknuti na classu open-window se otevre okno s obsahem
	$(".open-window").click(function () {
		$(this).parents(".description").find(".window").addClass('active')
	});
	$(".close-window").click(function () {
		$(".window").removeClass("active");
	});

	$('#myCollapsible').collapse()
});

$.fn.hasAttr = function (name) {
	return this.attr(name) !== undefined;
};

$(function () {
	$('.anchor, a[href*="#"]:not([href="#"],.no-scroll)').click(function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				smoothScrollTo(target, this.hash);
				return false;
			}
		}
	});
});

function smoothScrollTo(target, hash) {
	target = target.length ? target : $('[name=' + hash +']');

	if (target.length) {

		waypoints.preserverMenu = $("body").hasClass("product-menu--snap");

		var offset = 0;
		if(waypoints.preserverMenu) {
			var offset = $(".menu--placeholder").height() * -1;
		}

		$('html, body').animate({
			scrollTop: target.offset().top + offset
		}, 1000, function () {
			waypoints.preserverMenu = false;
		});
		location.hash = hash;

		return false;
	}
}
